const page_conservation = document.getElementById('page-conservation');

if (page_conservation) {

  //!---------- Landing Hero Section ----------

  //!---------- Conservation Slider ----------
  // init_large_card_slider(".initiatives .slider-card_large");
}